import { gql } from "utils/urql";
import Image from "components/Image";
import HomepageMetadata from "./HomepageMetadata";
import styles from "./SmallPromoItem.module.scss";
import { HomepageSmallPromoItemFragment } from "types/api";

type Props = HomepageSmallPromoItemFragment & {
  analyticsSection: string;
  riverIndex: number;
  lazyImage: boolean;
};

const SmallPromoItem = ({
  title,
  url,
  riverImage,
  authors,
  analyticsSection,
  riverIndex,
  lazyImage,
}: Props) => {
  return (
    <article className={styles.root}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          <a
            href={url}
            className={styles.titleLink}
            data-action={`click link - ${analyticsSection} - title ${riverIndex}`}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </h2>
        <HomepageMetadata
          authors={authors}
          analyticsSection={analyticsSection}
          riverIndex={riverIndex}
        />
      </div>

      {riverImage && (
        <a
          className={styles.image}
          href={url}
          data-action={`click link - ${analyticsSection} - image ${riverIndex}`}
        >
          <Image
            lazy={lazyImage}
            src={riverImage.url}
            srcSet={riverImage.srcSet}
            alt={riverImage.altText}
            width={riverImage.width}
            height={riverImage.height}
          />
        </a>
      )}
    </article>
  );
};

SmallPromoItem.fragment = gql`
  fragment homepageSmallPromoItem on HomepagePromoItem {
    id
    title
    dek
    url
    authors {
      id
      displayName
      url
    }
    riverImage(width: 86, height: 86, sizes: ["1x", "2x"]) {
      url
      width
      height
      srcSet
      altText
    }
  }
`;

export default SmallPromoItem;
